import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import { externalGateways } from '@/common/constants'
import AppContext from '@/common/context/app.context'

import IntegrationSettings from './IntegrationSettings/IntegrationSettings'
import { getSaveLabelButtonByIntegrationType, getSaveLoadingLabelButtonByIntegrationType } from './helpers'

const DefaultIntegration = ({ integration, onChange, hasChanges, onRevertChanges, onSave }) => {
  const { t } = useTranslation()
  const { info } = useContext(AppContext)

  const isStripe = integration?.type === externalGateways.stripe
  const isStripeConnected = info?.billing_data?.external_connected_gateway === externalGateways.stripe

  return (
    <>
      <IntegrationSettings integration={integration} onChange={onChange} />
      <SaveChangesButtons
        onSave={onSave}
        hasChanges={hasChanges || (isStripe && !isStripeConnected)}
        onRevertChanges={onRevertChanges}
        defaultLabel={t(getSaveLabelButtonByIntegrationType(integration?.type, isStripeConnected))}
        loadingLabel={t(getSaveLoadingLabelButtonByIntegrationType(integration?.type, isStripeConnected))}
      />
    </>
  )
}

export default DefaultIntegration
